import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorFundWithdrawSearch = () => {
  const fundWithdrawSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-withdraw/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { fundWithdrawSearch }
}

export default InteractorFundWithdrawSearch
